import { useBrandData } from "../hooks/useBrandData";
import { Instagram, Facebook } from "lucide-react";

const TikTokIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width={props.size || 14}
    height={props.size || 14}
    fill="none"
    stroke="currentColor"
    strokeWidth={props.strokeWidth || 1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

export default function Footer() {
  const { brand } = useBrandData();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0a0908] border-t border-[#d4af37]/15 pt-20 pb-10"
    >
      <div className="max-w-[1480px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-12 mb-16 md:grid-cols-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <img src={brand.logoUrl} alt="logo" className="h-16" />
              <div>
                <p className="font-display text-2xl text-[#fdfbf7] tracking-[0.2em]">
                  ADIBAH
                </p>
                <p className="text-[10px] tracking-[0.4em] uppercase text-[#d4af37]">
                  Sanggar Rias
                </p>
              </div>
            </div>
            <p className="text-sm text-[#a6a196] leading-relaxed max-w-sm">
              MUA profesional berbasis di Bekasi, Karawang, dan Jakarta. Sejak
              2017, Sanggar Rias Adibah telah menangani berbagai kebutuhan
              riasan — dari wedding, akad, lamaran, wisuda, hingga editorial —
              dengan signature glam look yang natural.
            </p>
          </div>

          {/* Sitemap */}
          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.4em] uppercase text-[#d4af37] mb-5">
              Jelajahi
            </p>
            <ul className="space-y-3 text-sm text-[#fdfbf7]/80">
              {["Tentang", "Layanan", "Karya", "Paket", "Kontak"].map((l) => (
                <li key={l}>
                  <button
                    onClick={() =>
                      document
                        .getElementById(
                          l.toLowerCase() === "tentang"
                            ? "about"
                            : l.toLowerCase() === "layanan"
                              ? "services"
                              : l.toLowerCase() === "karya"
                                ? "portfolio"
                                : l.toLowerCase() === "paket"
                                  ? "packages"
                                  : "contact",
                        )
                        ?.scrollIntoView({
                          behavior: "smooth",
                        })
                    }
                    className="hover:text-[#d4af37] transition-colors"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p className="text-[10px] tracking-[0.4em] uppercase text-[#d4af37] mb-5">
              Atelier
            </p>
            <p className="text-sm text-[#fdfbf7]/80 leading-relaxed mb-3">
              {brand.address}
            </p>
            <p className="text-sm text-[#fdfbf7]/80">{brand.phone}</p>
            <p className="text-sm text-[#fdfbf7]/80">{brand.email}</p>

            <div className="flex items-center gap-3 mt-6">
              {[
                {
                  Icon: Instagram,
                  href: brand.socials.instagram,
                  label: "instagram",
                },
                {
                  Icon: Facebook,
                  href: brand.socials.facebook,
                  label: "facebook",
                },
                {
                  Icon: TikTokIcon,
                  href: brand.socials.tiktok,
                  label: "tiktok",
                },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${label}`}
                  className="w-10 h-10 border border-[#d4af37]/30 flex items-center justify-center text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a0908] transition-all"
                >
                  <Icon size={14} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-[#d4af37]/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-[10px] tracking-[0.3em] uppercase text-[#a6a196]">
          <p>
            © {new Date().getFullYear()} Sanggar Rias Adibah · All Rights Reserved
          </p>
          <div className="flex items-center gap-4">
            <a href="/privacy-policy" className="hover:text-[#d4af37] transition-colors">
              Kebijakan Privasi
            </a>
            <span className="text-[#d4af37]/30">·</span>
            <a href="/terms-of-service" className="hover:text-[#d4af37] transition-colors">
              Syarat & Ketentuan
            </a>
          </div>
          <p className="font-display text-[#d4af37]">
            Crafted with ✦ in Jakarta
          </p>
        </div>
      </div>
    </footer>
  );
}
